/**
 * Carousel JS
 *
 * JS for carousels.
 */

import './frontpage-countdown';
import './banner-carousel';
import './shop-carousel';
import './social-proof-carousel';
import './tiles-carousel';
import './quote-carousel';
